const articleMandyLynn = {
    "key": "w03",
    "title": "Mandy Lynn Plans",
    "skills": "Graphic Design | Branding | Illustration",
    "date": "",
    "path": "icon-sets",
    "graphic": "icon-sets/MandyLynn_Cover.png",
    "graphicReposition": "50% 50%",
    "content": [
      {
        "component": "Title",
        "content": "Mandy Lynn Plans Sticker Designs"
      },
      {
        "component": "Subheading",
        "design": "centered",
        "content": "Graphic Design | Branding | Illustration"
      },
      {
        "component": "Heading",
        "content": "Overview"
      },
      {
        "component": "Image",
        "source": "icon-sets/MandyLynn_IconPrinting.png",
        "alt": "image of Mandy Lynn plans product that utilizes icon designs made by Nick Burgher"
      },
      {
        "component": "Body",
        "content": "In 2020, my friend Amanda asked if I could help her with designing a series of bespoke sticker designs for her business, <a href=\"https://mandylynnplans.com\" target=\"_blank\">Mandy Lynn Plans</a>. She offers unique, custom-designed materials for popular planners, such as those offered by Hobonichi and Wonderland 222. I was excited to collaborate with her on 30 fun and joyful sticker icons she was able to sell in a variety of&nbsp;colorways to her clientele."
      },
      {
        "component": "Image",
        "source": "icon-sets/MandyLynn_Samples.png",
        "alt": "a sampling of graphics created for MLP"
      },
      {
        "component": "Body",
        "design": "caption centered",
        "content": "A few of my favorite designs we did."
      },
      {
        "component": "Heading",
        "content": "Final Product"
      },
      {
        "component": "YoutubeEmbed",
        "embedId": "IbupDDkqrnc",
        "startAt": "62"
      },
      {
        "component": "Gallery",
        "galleryType": "masonry",
        "content": [
          {
            "source": "icon-sets/ML_sticker1.jpg",
            "alt": "picture of product: laundry basket"
          },
          {
            "source": "icon-sets/ML_sticker2.jpg",
            "alt": "picture of product: tea cup"
          },
          {
            "source": "icon-sets/ML_sticker3.jpg",
            "alt": "picture of product: spray bottle"
          },
          {
            "source": "icon-sets/ML_sticker4.jpg",
            "alt": "picture of product: church"
          },
          {
            "source": "icon-sets/ML_sticker5.jpg",
            "alt": "picture of product: $ sign"
          },
          {
            "source": "icon-sets/ML_sticker6.jpg",
            "alt": "picture of product: television"
          },
          {
            "source": "icon-sets/ML_sticker7.jpg",
            "alt": "picture of product: mail envelope"
          },
          {
            "source": "icon-sets/ML_sticker8.jpg",
            "alt": "picture of product: coffee cup"
          }
        ]
      },
      {
        "component": "Heading",
        "content": "Design Process"
      },
      {
        "component": "Combination",
        "design": "body-one-third align-top",
        "title": "Initial Concepts",
        "content": "For each icon, I started by drawing out some initial concepts. I referenced photographs or physical objects. I tried to avoid looking at icons done by other people, in order to ensure my designs were unique, packed with fresh ideas of my own. I also had a specific hand-crafted look I was going for that I really leaned into. I tried to keep the creativity flowing by exploring unconventional poses and different visual elements to help the designs stand on their own.",
        "source": "icon-sets/MandyLynn_PreliminarySketches_Book.jpg",
        "alt": "Preliminary sketches of designs",
        "caption": "Preliminary sketches and final design plan for the book icon. These were drawn in OneNote. I found the drawing limitations of the software helped me focus more on the design and less on the perfection of the illustration."
      },
      {
        "component": "Body",
        "content": "After finding a pose I liked, I would work on converting the shape to just one color. I would use the negative space in and around the object to add extra details like shadows. Once I worked out the one-color version, I would sketch the next icon in the set. This helped me stay creative while I worked and allowed me to see the whole set before I moved on to the vectorization process. It also allotted me extra time to tweak the designs and check consistency across the group, making the final product more cohesive."
      },
      
      {
        "component": "Image",
        "source": "icon-sets/MandyLynn_DesignPreviews.jpg",
        "alt": "Early previews of sticker drawings"
      },
      {
        "component": "Body",
        "design": "centered caption",
        "content": "I tightly collaborated with Amanda to bring the product to life. We passed back many messages to discuss intricacies with the designs and clarify the vision. I would at times pass along early sketches to make sure we were heading in the right direction."
      },
      {
        "component": "Subheading",
        "content": "Vectorization"
      },
      {
        "component": "Body",
        "content": "I created the final visuals with Figma! I chose Figma over Illustrator because it gave me greater control over batch processing the images. I was also able to create greater visual consistency because I could see and interact with every icon design at the same time. Mandy's team was able to use the jpg and SVG files exported from Figma to create all their sticker variations."
      },
      {
        "component": "Image",
        "source": "icon-sets/MandyLynn_FigmaProcess.jpg"
      },
      {
        "component": "Heading",
        "content": "Conclusion"
      },
      {
        "component": "Combination",
        "design": "one-third",
        "content": "Mandy Lynn Plans continues to sell these icons in sticker packs available on <a href=\"https://www.etsy.com/shop/mandylynnplans?ref=return_to_search&section_id=26061476&page=1#items\" target=\"_blank\">Etsy</a>. Their \"print-on-demand\" services give them the flexibility to offer a very large selection of materials with minimal inventory costs. These icons continue to be a main staple to their product&nbsp;line.",
        "source": "icon-sets/MandyLynn_Etsy.png"
      },
      {
        "component": "Button",
        "destination": "https://www.etsy.com/shop/mandylynnplans?ref=return_to_search&section_id=26061476&page=1#items",
        "content": "See Mandy Lynn Plans on Etsy",
        "target": "_blank",
        "design": "button-1"
      }
    ]
}

export default articleMandyLynn;